export class PremiumPayerDto {
  premiumSplit: boolean;
  premiumPayerIBAN: string;
}
